import React, { forwardRef } from "react";

import { Carousel as AntCarousel } from "antd";

import { useAppType } from "utils";

const KlimCarousel = ({ type, autoplay, children, afterChange = () => {}, forwardedRef, slidesToShow, inDrawer, infinite, dots }) => {
  const appType = useAppType();

  const getSlidesToShow = () => {
    if (slidesToShow) {
      return slidesToShow;
    }
    if (appType.desktop) {
      return 1.8;
    }
    return 1.1;
  };

  const miniProps = {
    slidesToShow: getSlidesToShow(),
    dots: false,
    infinite: false,
    arrows: false,
    className: `mini ${appType.desktop && inDrawer ? "in-drawer" : ""}`,
    draggable: appType.desktop,
  };

  const largeProps = {
    slidesToShow: getSlidesToShow(),
    autoplay: autoplay,
    autoplaySpeed: 8000,
    draggable: true,
    easing: "ease-in-out",
    dotPosition: "bottom",
    afterChange: afterChange,
    arrows: false,
    infinite: infinite || false,
    dots: dots || false,
  };

  const carouselProps = type === "mini" ? miniProps : largeProps;

  return (
    <AntCarousel ref={forwardedRef} {...carouselProps}>
      {children}
    </AntCarousel>
  );
};

export const Carousel = forwardRef((props, ref) => <KlimCarousel {...props} forwardedRef={ref} />); //eslint-disable-line
